// extracted by mini-css-extract-plugin
module.exports = {"box-tab":"BizGoodsDataViewTabs_box-tab__1XJSy","tab":"BizGoodsDataViewTabs_tab__198P9","open":"BizGoodsDataViewTabs_open__f_fns","hide":"BizGoodsDataViewTabs_hide__3FSHr"};